import React, { useCallback } from "react";
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from "@mui/x-data-grid-pro";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store";
import { validateTable } from "store/reducers/products/tables/tables.actions";

export type TableSummaryGridAction_ValidateProps = Extract<
  GridActionsCellItemProps,
  { showInMenu: true }
> & {
  readonly tableId: string;
};

export function TableSummaryGridAction_Validate({
  tableId,
  ...props
}: TableSummaryGridAction_ValidateProps) {
  const dispatch = useDispatch<AppDispatch>();

  const handleValidate = useCallback(() => {
    dispatch(validateTable({ tableId }));
  }, [dispatch, tableId]);

  return <GridActionsCellItem {...props} showInMenu onClick={handleValidate} />;
}
